<template>
  <div class="param over-scroll">
    <h3 v-for="(o, i) in curData"
        :key="i">{{i}}:{{o}}
    </h3>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('therapy', {
      curData: state => state.curData,
    }),
  },
}
</script>
